import React, { useEffect, useRef } from "react";
import Phaser from "phaser";

// Import scenes. If you don't have BootScene, TitleScene, or CharacterCreationScene defined yet,
// you can remove them from the scene list and start directly with PhaserMMOScene.
import BootScene from "./BootScene";             // Optional boot scene
import TitleScene from "./TitleScene";           // Title screen scene
import CharacterCreationScene from "./CharacterCreationScene"; // Character creation scene
import CharacterSelectScene from "./CharacterSelectScene";     // New scene for selecting saved characters
import PhaserMMOScene from "./Phasermmoscene";     // Main game scene

function Phasermmo() {
  const phaserRef = useRef(null);

  useEffect(() => {
    let game;
    if (!game) {
      game = new Phaser.Game({
        type: Phaser.AUTO,
        width: 800,
        height: 600,
        parent: phaserRef.current,
        pixelArt: true,
        // <-- Enable DOM support for Phaser (needed for input elements)
        dom: {
          createContainer: true
        },
        physics: {
          default: "arcade",
          arcade: {
            gravity: { y: 0 },
            debug: false,
          },
        },
        scene: [
          BootScene,             // Optional; remove if not needed
          TitleScene,            // Title screen scene
          CharacterSelectScene,
          CharacterCreationScene,  // Character creation scene
          PhaserMMOScene         // Main world scene
        ]
      });
      // Start with the TitleScene, or if you prefer, directly with CharacterCreationScene:
      game.scene.start("TitleScene");
    }

    return () => {
      if (game) {
        game.destroy(true);
      }
    };
  }, []);

  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Legend of Aetherwyn - 蒼穹之詠</h2>
      <div ref={phaserRef} />
    </div>
  );
}

export default Phasermmo;
